import {
    GET_BARCODE_ITEMS,
    SHOW_INVALID_BARCODE_DETAILS,
    SET_BARCODE_RECEIVE_ITEMS,
    SHOW_INVALID_BARCODE_POPUP,
    RESET_INVALID_BARCODE_DETAILS,
    RESET_BARCODE_ITEMS,
    GET_BARCODE_ITEMS_FAILURE,
    GET_BARCODE_ITEMS_SUCCESS,
    SUCCESS_MESSAGE_CAMERA,
} from '../actions/actionTypes';

const initialState = {
    barcodeDetails: {},
    invalidBarcodeDetails: [],
    isBarcodeLoading: false,
    showInvalidBarcodePopup: false,
    succesMessageCamera: false,
};

const BarCodeScannerReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_INVALID_BARCODE_DETAILS:
            return {
                ...state,
                invalidBarcodeDetails: action.payload,
            };
        case SHOW_INVALID_BARCODE_POPUP:
            return {
                ...state,
                showInvalidBarcodePopup: action.payload,
            };
        case RESET_INVALID_BARCODE_DETAILS:
            return {
                ...state,
                ...initialState,
            };
        case RESET_BARCODE_ITEMS:
            return {
                ...state,
                barcodeDetails: {},
            };
        case GET_BARCODE_ITEMS:
            return {
                ...state,
                payload: action.payload,
                isBarcodeLoading: true,
            };
        case GET_BARCODE_ITEMS_SUCCESS:
            return {
                ...state,
                barcodeDetails: action.payload,
                isBarcodeLoading: false,
            };
        case GET_BARCODE_ITEMS_FAILURE:
            return {
                ...state,
                barcodeDetails: action.payload,
                isBarcodeLoading: false,
            };
        case SET_BARCODE_RECEIVE_ITEMS:
            return {
                ...state,
                barcodeDetails: {},
            };
        case SUCCESS_MESSAGE_CAMERA:
            return {
                ...state,
                succesMessageCamera: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default BarCodeScannerReducer;
